import React from "react";
import { useLang } from "@/context/LanguageContext";
import { usePublicSettings } from "@/context/SettingsContext";

const Legal = ({ title, children }) => (
  <div className="pt-32 pb-24">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <h1 className="font-serif font-light text-4xl md:text-5xl text-petrol mb-10">{title}</h1>
      <div className="prose-fiorucci space-y-6 text-petrol/80 leading-relaxed">{children}</div>
    </div>
  </div>
);

export function Privacy() {
  const { t } = useLang();
  const s = usePublicSettings();
  return (
    <Legal title={t("footer.privacy")}>
      <p data-testid="privacy-page">
        {s.brand_name || "Fiorucci Apartments"} tratta i dati personali degli ospiti nel rispetto del Regolamento (UE) 2016/679 (GDPR).
      </p>
      <h3 className="font-serif text-2xl text-petrol">Titolare del trattamento</h3>
      <p>{s.brand_name || "Fiorucci Apartments"}{s.contact_email ? ` — ${s.contact_email}` : ""}.</p>
      <h3 className="font-serif text-2xl text-petrol">Dati raccolti</h3>
      <p>Raccogliamo i dati anagrafici e di contatto forniti tramite i moduli di prenotazione e di check-in online, nonché i documenti d’identità necessari agli adempimenti di legge (registrazione ospiti).</p>
      <h3 className="font-serif text-2xl text-petrol">Conservazione dei documenti</h3>
      <p>I documenti d’identità caricati durante il check-in <strong>non vengono conservati sui server del sito web</strong>. Vengono trasferiti in modo sicuro su uno spazio cloud privato (Aruba Drive / Nextcloud) accessibile solo al gestore. Nel database del sito è memorizzato unicamente il riferimento al percorso del file.</p>
      <h3 className="font-serif text-2xl text-petrol">Finalità</h3>
      <p>I dati sono trattati per la gestione della prenotazione, gli adempimenti di pubblica sicurezza e l’assistenza durante il soggiorno.</p>
      <h3 className="font-serif text-2xl text-petrol">Diritti dell’interessato</h3>
      <p>L’ospite può richiedere in ogni momento l’accesso, la rettifica o la cancellazione dei propri dati scrivendo ai recapiti di contatto.</p>
    </Legal>
  );
}

export function CookiePolicy() {
  const { t } = useLang();
  return (
    <Legal title={t("footer.cookie")}>
      <p data-testid="cookie-policy-page">Questo sito utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie di analisi per migliorare l’esperienza di navigazione.</p>
      <h3 className="font-serif text-2xl text-petrol">Cookie tecnici</h3>
      <p>Essenziali per il corretto funzionamento del sito (es. preferenza della lingua, sessione amministrativa). Non richiedono consenso.</p>
      <h3 className="font-serif text-2xl text-petrol">Cookie analitici</h3>
      <p>Utilizzati in forma aggregata per comprendere l’utilizzo del sito. Vengono attivati solo dopo l’accettazione tramite il banner cookie.</p>
      <h3 className="font-serif text-2xl text-petrol">Gestione del consenso</h3>
      <p>Puoi modificare le tue preferenze in qualsiasi momento cancellando i cookie dal tuo browser. Il banner ti permette di accettare o rifiutare i cookie non essenziali.</p>
    </Legal>
  );
}
